export default __webpack_public_path__ + "static/media/axis-icon.84353dc7.svg";